(function (root) {
  var LOUPE_ZOOM = 2.4;
  var HOVER_MQ = "(hover: hover) and (pointer: fine)";

  function canHoverLoupe() {
    return root.matchMedia && root.matchMedia(HOVER_MQ).matches;
  }

  function visibleImages(gallery) {
    var carousel = gallery.querySelector(".product-gallery__carousel");
    if (!carousel) return [];
    var cells = carousel.querySelectorAll(".product-gallery__media");
    var images = [];
    cells.forEach(function (cell) {
      if (cell.hasAttribute("hidden")) return;
      var image = cell.querySelector(":scope > img, :scope img");
      if (image) images.push(image);
    });
    return images;
  }

  function hideLoupe(loupe) {
    if (!loupe) return;
    loupe.hidden = true;
    loupe.classList.remove("is-visible");
  }

  function moveLoupe(event, item, gallery, loupe) {
    if (!canHoverLoupe() || !loupe) return;
    var image = item.querySelector("img");
    var stage = gallery.querySelector(".product-gallery__image-list") || gallery;
    if (!image || !stage) return;
    var itemRect = item.getBoundingClientRect();
    var stageRect = stage.getBoundingClientRect();
    var x = Math.min(1, Math.max(0, (event.clientX - itemRect.left) / itemRect.width));
    var y = Math.min(1, Math.max(0, (event.clientY - itemRect.top) / itemRect.height));
    loupe.hidden = false;
    var size = loupe.offsetWidth || 280;
    loupe.classList.add("is-visible");
    loupe.style.backgroundImage = 'url("' + (image.currentSrc || image.src) + '")';
    loupe.style.backgroundSize = itemRect.width * LOUPE_ZOOM + "px " + itemRect.height * LOUPE_ZOOM + "px";
    loupe.style.backgroundPosition = x * 100 + "% " + y * 100 + "%";
    loupe.style.left =
      Math.min(stageRect.width - size, Math.max(0, event.clientX - stageRect.left - size / 2)) + "px";
    loupe.style.top =
      Math.min(
        itemRect.bottom - stageRect.top - size,
        Math.max(itemRect.top - stageRect.top, event.clientY - stageRect.top - size / 2)
      ) + "px";
  }

  function ensureLoupe(gallery) {
    var loupe = gallery.querySelector("[data-fh-gallery-loupe]");
    if (loupe) return loupe;
    var stage = gallery.querySelector(".product-gallery__image-list");
    if (!stage) return null;
    loupe = root.document.createElement("div");
    loupe.className = "fh-product-gallery__loupe";
    loupe.setAttribute("data-fh-gallery-loupe", "");
    loupe.hidden = true;
    stage.appendChild(loupe);
    return loupe;
  }

  function bindLoupe(gallery) {
    if (gallery.getAttribute("data-fh-loupe-bound") === "true") return;
    gallery.setAttribute("data-fh-loupe-bound", "true");
    var loupe = ensureLoupe(gallery);
    if (!loupe) return;

    gallery.addEventListener("pointermove", function (event) {
      if (!canHoverLoupe() || event.pointerType === "touch") {
        hideLoupe(loupe);
        return;
      }
      var item = event.target.closest(".product-gallery__media");
      if (!item || item.hasAttribute("hidden") || !gallery.contains(item)) {
        hideLoupe(loupe);
        return;
      }
      if (item.getAttribute("data-media-type") && item.getAttribute("data-media-type") !== "image") {
        hideLoupe(loupe);
        return;
      }
      moveLoupe(event, item, gallery, loupe);
    });

    gallery.addEventListener("pointerleave", function () {
      hideLoupe(loupe);
    });
  }

  function setActiveThumbs(bar, index) {
    bar.querySelectorAll(".fh-pswp-thumbs__item").forEach(function (item, itemIndex) {
      item.classList.toggle("is-active", itemIndex === index);
    });
  }

  function attachLightboxThumbs(pswp, gallery) {
    if (!pswp || !pswp.element) return;
    var existing = pswp.element.querySelector("[data-fh-pswp-thumbs]");
    if (existing) existing.remove();

    var images = visibleImages(gallery);
    if (images.length < 2) return;

    pswp.element.classList.add("fh-pswp");
    var bar = root.document.createElement("div");
    bar.className = "fh-pswp-thumbs";
    bar.setAttribute("data-fh-pswp-thumbs", "");

    images.forEach(function (image, index) {
      var button = root.document.createElement("button");
      button.type = "button";
      button.className = "fh-pswp-thumbs__item" + (index === pswp.currIndex ? " is-active" : "");
      button.setAttribute("aria-label", "Bild " + (index + 1) + " anzeigen");
      var thumb = root.document.createElement("img");
      thumb.src = image.currentSrc || image.src;
      thumb.alt = "";
      button.appendChild(thumb);
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof pswp.goTo === "function") pswp.goTo(index);
      });
      bar.appendChild(button);
    });

    pswp.element.appendChild(bar);
    setActiveThumbs(bar, pswp.currIndex);
    pswp.on("change", function () {
      setActiveThumbs(bar, pswp.currIndex);
    });
  }

  function bindLightbox(gallery) {
    if (gallery.getAttribute("data-fh-lightbox-bound") === "true") return;
    gallery.setAttribute("data-fh-lightbox-bound", "true");

    gallery.addEventListener("lightbox:open", function () {
      var attempts = 0;
      var tryAttach = function () {
        var lightbox = gallery.lightBox;
        var pswp = lightbox && lightbox.pswp;
        if (pswp && pswp.element) {
          attachLightboxThumbs(pswp, gallery);
          return;
        }
        attempts += 1;
        if (attempts < 30) root.requestAnimationFrame(tryAttach);
      };
      root.requestAnimationFrame(tryAttach);
    });
  }

  function enhance(gallery) {
    if (!gallery || gallery.tagName !== "PRODUCT-GALLERY") return;
    gallery.classList.add("product-gallery--fh");
    bindLoupe(gallery);
    bindLightbox(gallery);
  }

  function bindAll(scope) {
    var rootEl = scope || root.document;
    if (!rootEl || !rootEl.querySelectorAll) return;
    rootEl.querySelectorAll("product-gallery").forEach(enhance);
  }

  root.fhBindProductGallery = bindAll;

  if (root.document) {
    if (root.document.readyState === "loading") {
      root.document.addEventListener("DOMContentLoaded", function () {
        bindAll(root.document);
      });
    } else {
      bindAll(root.document);
    }
    root.document.addEventListener("shopify:section:load", function (event) {
      bindAll(event.target);
    });
  }
})(typeof window !== "undefined" ? window : globalThis);
